// @flow
import React from 'react';

type Props = {
  noStock: boolean,
  modifier: ?string,
};

const STYLE_PREFIX = 'c-size-grid__item';

const SizeGridToken = (props: Props) => (
  <svg viewBox="0 0 16 16">
    <g>
      <circle
        className={
          props.noStock
            ? `${STYLE_PREFIX}--no-stock__circle`
            : `${STYLE_PREFIX}--${props.modifier}`
        }
        cx="8"
        cy="8"
        r="6"
      />
      {props.noStock && (
        <g className={`${STYLE_PREFIX}--no-stock__line`}>
          <line
            x1="6"
            y1="6"
            x2="10"
            y2="10"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
          <line
            x1="10"
            y1="6"
            x2="6"
            y2="10"
            strokeLinecap="round"
            strokeMiterlimit="10"
          />
        </g>
      )}
    </g>
  </svg>
);

export default SizeGridToken;
